/**
 * Created by lid3ip9 on 06/25/2017.
 */
module.exports = ['$scope', '$http', 'services', 'coremetrics', 'brand', '$cookies','invisibleFormService', function($scope, $http, services, coremetrics, brand, $cookies, invisibleFormService) {

    $scope.custom = true;

    $scope.connectToRetrofit = function(){
        coremetrics.elementTag('RETROFIT LINK ', 'MEMBER:WELLNESS:DIABETES PREVENTION PROGRAM');
        $scope.myCloseModal();
        var retroFitParams = {
            "brand": brand.current.umsBrandCode || brand.current.sharedBrandCode,
            "payload": {
                "clientNumber":$cookies.get("mbrClientNumber"),
                "groupNumber": $cookies.get("mbrGroupNumber"),
                "targetType": "PREPWD",
                "vendorName": "Retrofit",
                "category": "DIABETES_PREVENTION_PROGRAM",
                "returnUrl": "",
                "returnPage": ""
            }
        };
        services.rbsmbl.vendor().fetch(retroFitParams).then(function(retroFitResp) {

            var ssoUrl = retroFitResp.data.payload.ssoUrl;
            var urlAppend = (ssoUrl.indexOf("?") > -1) ? "&" : "?";
            var theUrl = ssoUrl + urlAppend + 'cm_sp= DiabetesPrevention -_-Continue-_-Retrofit';
            var retroFormConfig = {
                "name": "ssoFormName",
                "id": "InvisibleFormId",
                "formTarget": "retroFitWindow",
                "method": "POST",
                "action": theUrl, //retroFitResp.data.payload.ssoUrl,
                "target": "_blank",
                "inputs": {
                    "SAMLResponse": retroFitResp.data.payload.ssoFormParams[0].value
                }
            };
            invisibleFormService.submit(retroFormConfig);
        }, function(retroFitErr) {
            console.log("Error", retroFitErr);
        });
    }

    $scope.myCloseModal = function() {
        this.closeModal();
    }

}];